import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMusic, faGuitar, faHeadphones, faBook, faPlay, faTrophy } from '@fortawesome/free-solid-svg-icons';
import Tablature from '../Pages/Tablature';

const HomeGrid = () => {
  return (
    <main>
    <section className="home-grid">

      <h1 className="heading">Bienvenue sur Ukulearn!</h1>

      <article className="box-container">

        <section className="box">
          <h3 className="title">Derniers tutoriels</h3>
          <p className="text">Découvrez nos derniers tutoriels de ukulélé pour perfectionner votre jeu.</p>
          <NavLink to="/tablature" className="purple-btn">Explorer les tutoriels</NavLink>
        </section>

        <section className="box">
          <h3 className="title">Catégories populaires</h3>
          <ul className="flex">
            <li><Link to="/#"><FontAwesomeIcon icon={faMusic} /> Accords de base</Link></li>
            <li><Link to="/#"><FontAwesomeIcon icon={faGuitar} /> Techniques de strumming</Link></li>
            <li><Link to="/#"><FontAwesomeIcon icon={faHeadphones} /> Ukulélé et enregistrement</Link></li>
            <li><Link to="/#"><FontAwesomeIcon icon={faBook} /> Leçons avancées</Link></li>
          </ul>
        </section>

        <section className="box">
          <h3 className="title">Articles populaires</h3>
          <ul className="flex">
            <li><Link to="#"><FontAwesomeIcon icon={faPlay} /> 10 chansons faciles à jouer</Link></li>
            <li><Link to="#"><FontAwesomeIcon icon={faTrophy} /> Maîtriser le fingerpicking</Link></li>
            <li><Link to="#"><FontAwesomeIcon icon={faHeadphones} /> Choisir le bon ukulélé</Link></li>
            <li><Link to="#"><FontAwesomeIcon icon={faMusic} /> Improvisation créative</Link></li>
          </ul>
        </section>

        <section className="box">
          <h3 className="title">Partagez votre expérience</h3>
          <p className="text">Écrivez pour nous! Partagez vos propres astuces avec la communauté.</p>
          <NavLink to="/communaute" className="purple-btn">Commencer à écrire</NavLink>
        </section>

      </article>
      <Tablature />

    </section>
    </main>
  );
};

export default HomeGrid;
